import {
  InternalRequestRequestorListPage,
  InternalRequestRequestorNewReceivePage,
  InternalRequestRequestorNewDetailPage,
  InternalRequestRequestorArchiveListPage,
  InternalRequestRequestorArchiveDetailPage,
  InternalRequestRequestorNewCreatePage,
  InternalRequestRequestorOngoingListPage,
  InternalRequestRequestorViewDetailPage
} from 'domains/internal-request-requestor'

/**
 * Used by:
 *  - `<Sidebar>` to generate the NavItems
 *  - `<App>` to generate react-router a list of `<Route path={..} component={..}/>`
 *
 * Key Definitions:
 *
 * - `path`: the URL that the component will be displayed in
 * - `name`: Sidebar display
 * - `component`: Component to display
 * - `layout`: always /app
 */
const all_team_internal_requests_routes = [
  {
    path      : '/internal-requests/requestor/new',
    name      : 'New Request',
    miniName  : 'N',
    component : InternalRequestRequestorListPage,
    layout    : '/app'
  },
  {
    path      : '/internal-requests/requestor/new/create',
    name      : 'Requestor Create',
    miniName  : 'NC',
    component : InternalRequestRequestorNewCreatePage,
    layout    : '/app',
    invisible : true
  },
  {
    path      : '/internal-requests/requestor/new/:id/receive',
    name      : 'Requestor Receive',
    miniName  : 'NR',
    component : InternalRequestRequestorNewReceivePage,
    layout    : '/app',
    invisible : true
  },
  {
    path      : '/internal-requests/requestor/new/:id',
    name      : 'New Detail',
    miniName  : 'ND',
    component : InternalRequestRequestorNewDetailPage,
    layout    : '/app',
    invisible : true
  },
  {
    path      : '/internal-requests/requestor/archive',
    name      : 'Borrowed History',
    miniName  : 'BH',
    component : InternalRequestRequestorArchiveListPage,
    layout    : '/app'
  },
  {
    path      : '/internal-requests/requestor/archive/:id',
    name      : 'Borrowed History Detail',
    miniName  : 'AD',
    component : InternalRequestRequestorArchiveDetailPage,
    layout    : '/app',
    invisible : true
  },
  {
    path      : '/internal-requests/requestor/ongoing',
    name      : 'Ongoing Request',
    miniName  : 'OG',
    component : InternalRequestRequestorOngoingListPage,
    layout    : '/app'
  },
  {
    path      : '/internal-requests/requestor/ongoing/:id',
    name      : 'Ongoing Detail',
    miniName  : 'OK',
    component : InternalRequestRequestorViewDetailPage,
    layout    : '/app',
    invisible : true
  }
]

export default all_team_internal_requests_routes
